import Component from './src/Header';

export * from './src/Header';
export default Component;
